import { idfcGetAccountDetail, idfcMultiPaymentEnquiry } from "_services";
import { useAuthFlow } from "hooks";
import React, { useState } from "react";

const TableOfDetails = ({ columns, data = [], isLoading = false, actionButtons = [], isAnyButtonVisible = false, refreshPaymentAprovel }) => {
    const [isLoadingBank, setLoadingBank] = useState(null)

    const callBack = async (data, auth_token, dataA, selectedItem) => {
        try {
            setLoadingBank(true)
            const param = {
                access_token: `Bearer ${data?.auth_token}`,
                idfc_transaction_id: selectedItem?.idfc_transaction_id,
            }
            if (selectedItem?.idfc_transaction_id) {
                const resp = await idfcMultiPaymentEnquiry(param)
            }
            setLoadingBank(false)
            refreshPaymentAprovel()
        } catch (error) {
            setLoadingBank(false)
        }
    }

    const { fetchWithAuth } = useAuthFlow(callBack);

    const getIdfcAccDetail = async (k) => {
        setLoadingBank(false)
        try {
            const param = {
                cb_account_id: k?.cb_account_id,
            };
            const res = await idfcGetAccountDetail(param);
            fetchWithAuth(res?.data, false, k);
        } catch (error) {

        }
    }
    return (
        <React.Fragment>
            {isLoadingBank && (
                <div
                    class="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 text-white"
                    style={{ zIndex: 1000, background: "rgba(0,0,0,0.8)" }}
                >
                    <div>...Please wait</div>
                </div>
            )}
            <div className='_transactionTable __toggledTable'>
                <table className="">
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th key={`${index}_${column.header}`}>
                                    <div className="_minTh_wid">{column.header}</div>
                                </th>
                            ))}

                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {!isLoading ? (
                            <React.Fragment>

                                {data.length > 0 ? (
                                    data?.map((row, rowIndex) => {
                                        return (
                                            <>
                                                <tr key={`${rowIndex}_${rowIndex}`}>
                                                    {columns.map((column, colIndex) => (
                                                        <td key={`${colIndex++}`}>{row[column.accessor]}</td>
                                                    ))}
                                                </tr>
                                                {isAnyButtonVisible &&
                                                    <tr className='__actionRow'>
                                                        <td colSpan={columns.length + 1}>
                                                            <div className='__hrd_TDbx'>
                                                                <div className='__pmtActionBtns'>
                                                                    {actionButtons?.map((button, btnIndex) => {
                                                                        const shouldShow = typeof button?.isShow === 'function'
                                                                            ? button.isShow(row)
                                                                            : button?.isShow;
                                                                        return (
                                                                            <React.Fragment key={`btn_${btnIndex}`}>
                                                                                {shouldShow && (
                                                                                    <button
                                                                                        className={`${button.className} anime-btn`}
                                                                                        onClick={() => button.onClick(row, rowIndex)}
                                                                                    >
                                                                                        {button.label}
                                                                                    </button>
                                                                                )}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </div>
                                                                {refreshPaymentAprovel && <button className={`__pmtApprovBtn anime-btn`} onClick={() => {
                                                                    if (row) {
                                                                        // fetchWithAuth(k.cb_data);
                                                                        getIdfcAccDetail(row)
                                                                    }
                                                                }}
                                                                >
                                                                    Refresh Status
                                                                </button>}
                                                            </div>
                                                        </td>
                                                    </tr>}

                                                <tr className='__emptyRow'>
                                                    <td colSpan={6}></td>
                                                </tr>
                                            </>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td>
                                            <span className="_tblText">No data</span>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <tr>
                                    <td>
                                        <span className="_tblText">Loadding...</span>
                                    </td>
                                </tr>
                                ;
                            </React.Fragment>
                        )}
                    </tbody>
                </table>
            </div>
        </React.Fragment>

    );
};

export default TableOfDetails;